import { Pipe, PipeTransform } from '@angular/core';

/**
 * Formats conversation timestamps for compact UI:
 * - under 1 hour: minutes (e.g. "5 min ago")
 * - under 24 hours: whole hours (e.g. "3h ago")
 * - older: short locale date
 */
@Pipe({
  name: 'conversationRelativeDate',
  standalone: true,
})
export class ConversationRelativeDatePipe implements PipeTransform {
  transform(value: string | Date | null | undefined): string {
    if (value == null || value === '') {
      return '';
    }
    const d = typeof value === 'string' ? new Date(value) : value;
    if (Number.isNaN(d.getTime())) {
      return '';
    }

    const now = Date.now();
    const diffMs = now - d.getTime();
    const minuteMs = 60_000;
    const hourMs = 60 * minuteMs;
    const dayMs = 24 * hourMs;

    if (diffMs < 0) {
      return d.toLocaleDateString(undefined, { month: 'short', day: 'numeric', year: 'numeric' });
    }

    if (diffMs < minuteMs) {
      return 'Just now';
    }

    if (diffMs < hourMs) {
      const mins = Math.floor(diffMs / minuteMs);
      return mins === 1 ? '1 min ago' : `${mins} min ago`;
    }

    if (diffMs < dayMs) {
      const hours = Math.floor(diffMs / hourMs);
      return hours === 1 ? '1h ago' : `${hours}h ago`;
    }

    return d.toLocaleDateString(undefined, { month: 'short', day: 'numeric', year: 'numeric' });
  }
}
